<link rel="stylesheet" href="https://sandbox.optomiser.com/StyleBundle/FontAwesome" />

<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="currentItem==null">
    <div class="float-end">
      <a class="btn btn-secondary" [routerLink]="['/navigation/links']">View links</a>
    </div>
    <h1 class="content-heading-font">Navigation Categories</h1>


    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list?.Result"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [totalRecords]="list?.FilteredRecords"
                 [lazy]="true"
                 (onLazyLoad)="loadTable($event)"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
                 sortMode="multiple">


          <ng-template pTemplate="header">
            <tr>
              <th class="text-end" style="width:120px;"></th>
              <th pSortableColumn="ID" class="text-end d-none d-md-table-cell">
                #
                <p-sortIcon field="ID"></p-sortIcon>
                <p-columnFilter type="numeric" field="ID" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="CategoryName" class="text-start">
                Name
                <p-sortIcon field="CategoryName"></p-sortIcon>
                <p-columnFilter type="text" field="CategoryName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="HeaderName" class="text-start  d-none d-md-table-cell">
                Header <p-sortIcon field="HeaderName"></p-sortIcon>
                <p-columnFilter type="text" field="HeaderName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="URL" class="text-start  d-none d-xxl-table-cell">
                URL <p-sortIcon field="URL"></p-sortIcon>
                <p-columnFilter type="text" field="URL" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Icon" class="text-center d-none d-xl-table-cell">
                Icon <p-sortIcon field="Icon"></p-sortIcon>
                <p-columnFilter type="text" field="Icon" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="IsPatientNav" class="text-start d-none d-xxl-table-cell">
                Is Patient <p-sortIcon field="IsPatientNav"></p-sortIcon>
                <p-columnFilter type="boolean" field="IsPatientNav" matchMode="contains" display="menu" [showMatchModes]="false" [showOperator]="false">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [options]="[{ name: 'Any', value: '' },{ name: 'No', value: 'false' },{ name: 'Yes', value: 'true' }]" [ngModel]="value" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pSortableColumn="NavigationLinks" class="text-end d-none d-xxl-table-cell">
                Links <p-sortIcon field="NavigationLinks"></p-sortIcon>
                <p-columnFilter type="numeric" field="NavigationLinks" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <th class="text-end">
                <div class="gap-2 d-block ">
                  <a class="btn btn-sm btn-primary me-1 " (click)="onRowEditInit(item)" title="Edit">
                    <i class="pi pi-pen-to-square"></i>
                  </a>
                  <a class="btn btn-sm btn-warning  " (click)="onRowDeleteInit(item)" title="Delete">
                    <i class="pi pi-trash"></i>
                  </a>
                </div>
              </th>
              <th class="text-end d-none d-md-table-cell">{{ item.ID }}</th>
              <td>
                {{ item.CategoryName }}
              </td>
              <td class=" d-none d-md-table-cell">{{ item.HeaderName }}</td>
              <td class=" d-none d-xxl-table-cell text-truncate">{{ item.URL }}</td>
              <td class=" d-none d-xl-table-cell text-center"><i class="fa {{ item.Icon }}" *ngIf="item.Icon!=null"></i></td>
              <td class=" d-none d-xxl-table-cell fw-bold">
                <div [ngClass]="{'text-danger': !item.IsPatientNav, 'text-success': item.OpenToBeAssigned}">
                  {{ item.IsPatientNav?'Yes':'No' }}
                </div>
              </td>
              <td class="text-end d-none d-xxl-table-cell">
                <a href="#" [routerLink]="['/navigation/links']" [queryParams]="{NavCategoryID: item.ID}">
                  {{ item.NavigationLinks |  number  }}
                </a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">
            <button class="btn btn-primary " (click)="addItem(dt1)" title="Add item">
              <i class="pi pi-plus"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="loadTable(null)" title="Refress">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary " (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8">No items found.</td>
            </tr>
          </ng-template>
        </p-table>



      </div>
    </div>

  </div>

  <div class="main-page-content-block" *ngIf="currentItem!=null">
    <div class="float-end">
      <a class="btn btn-secondary" (click)="cancel()">View list</a>
    </div>

    <h1 class="content-heading-font">
      <span *ngIf="currentItem && currentItem.ID">
        Navigation Category #{{currentItem.ID }} - {{currentItem.CategoryName }}
      </span>
      <span *ngIf="!(currentItem && currentItem.ID)">
        New Navigation Category
      </span>
    </h1>


    <form #itemForm="ngForm" [formGroup]="itemFormGroup">
      <div class="row">
        <div class="col mb-3">
          <label for="CategoryName">Name</label>
          <input class="form-control" name="CategoryName" formControlName="CategoryName" autocomplete="off" placeholder="Name" required="required" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="HeaderName">Header</label>
          <input class="form-control" name="HeaderName" formControlName="HeaderName" autocomplete="off" [placeholder]="currentItem.CategoryName || 'Header' " />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="URL">URL</label>
          <input class="form-control" name="URL" formControlName="URL" autocomplete="off" placeholder="" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="Icon">Icon <a href="https://fontawesome.com/v6/icons" target="icons"><i class="ms-2 pi pi-info-circle" style="font-size: 0.7rem"></i></a></label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa-fw {{ IconValue }}" *ngIf="IconValue"></i></div>
            </div>
            <input class="form-control" name="Icon" formControlName="Icon" autocomplete="off" placeholder="Icon" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="OrderNumber">Order Number</label>
          <input type="number"  min="0" max="100" class="form-control" name="OrderNumber" formControlName="OrderNumber" autocomplete="off" placeholder="" />
        </div>
      </div>
      <div class="row">
        <div class="col mb-3">
          <label for="IsPatientNav">Is Patient Navigation Category?</label>
          <select class="form-control" name="IsPatientNav" formControlName="IsPatientNav">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-lg btn-primary" type="submit" id="btnSave" [class.button-loading]="loading" (click)="save()">Save</button>
        </div>
      </div>
    </form>
  </div>
</div>

